import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-servicecontactform").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 750,
    slidesPerView: 1,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    simulateTouch: false,
  });
});
